import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Manrope\",\"arguments\":[{\"subsets\":[\"latin\",\"latin-ext\"],\"weight\":[\"400\",\"500\",\"600\",\"700\",\"800\"],\"variable\":\"--font-main\",\"display\":\"swap\"}],\"variableName\":\"mainFont\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/[locale]/globals.css");
